<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-context-bar slds-m-top--xxx-small slds-p-left_medium">
  <div class="slds-context-bar__primary">
    <div
      class="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
      <div class="slds-context-bar__icon-action">
        <button (click)="doShowAppLauncher()"
                class="slds-button slds-icon-waffle_container slds-context-bar__button"
                id="nav-app-launcher"
                i18n-title title="Menu">
          <span class="slds-icon-waffle">
            <span class="slds-r1"></span>
            <span class="slds-r2"></span>
            <span class="slds-r3"></span>
            <span class="slds-r4"></span>
            <span class="slds-r5"></span>
            <span class="slds-r6"></span>
            <span class="slds-r7"></span>
            <span class="slds-r8"></span>
            <span class="slds-r9"></span>
          </span>
          <span class="slds-assistive-text" i18n>Menu</span>
        </button>
      </div>
    </div>
  </div>

  <nav class="slds-context-bar__secondary" role="navigation">
    <ul class="slds-grid slds-truncate" id="nav-menu-list">

      <!-- Open -->
      <li *ngIf="isInIFrame"
          class="slds-context-bar__item">
        <a class="slds-context-bar__label-action"
           href="/"
           id="nav-open-tab"
           target="_blank"
           i18n-title title="Open in Tab">
          <svg aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-error menu-icon">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#open"></use>
          </svg>
          Open
        </a>
      </li>
      <!-- Home -->
      <li class="slds-context-bar__item">
        <a [target]="isInIFrame ? '_blank' : '_self'"
           class="slds-context-bar__label-action"
           id="nav-home"
           routerLink="/"
           style="padding: 0 .5rem"
           i18n-title title="Home">
          <svg aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-success menu-icon">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#home"></use>
          </svg>
        </a>
      </li>

      <li *ngFor="let mi of mainMenuItems"
          class="slds-context-bar__item"
          style="min-width: 80px"
          routerLinkActive="slds-is-active">
        <a [id]="mi.id()"
           [routerLink]="mi.routerLink()"
           [title]="mi.description"
           class="slds-context-bar__label-action">
          <span class="slds-icon_container">
            <img *ngIf="mi.iconHref?.endsWith('.svg')"
                 [src]="mi.iconHref"
                 [alt]="mi.label"
                 class="menu-icon"/>
            <svg *ngIf="mi.iconHref?.includes('#')"
                 aria-hidden="true"
                 class="slds-icon slds-icon_small slds-icon-text-default menu-icon">
              <use [attr.xlink:href]="mi.iconHref"/>
            </svg>
            <span class="slds-assistive-text">{{mi.label}}</span>
          </span>
          <span class="slds-truncate">{{mi.label}}</span>
        </a>
      </li>

    </ul>
  </nav>

</div>
<acc-app-launcher (menuSelected)="onMenuSelected($event)"
                  *ngIf="showAppLauncher"
                  [menuItems]="menuItems"></acc-app-launcher>
